import Model from './model'

export default class Feature extends Model {
  constructor() {
    super()
    this.hydrate({
      title: '',
      body: ''
    })
  }
}
